"use client"

import { z } from 'zod'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table'
import { FtpSchema } from '@/schemas/ftp.schema'
import FtpModal from './FtpModal'
import FtpEditModal from './FtpEditModal'
import { Check, X } from 'lucide-react'
import FtpDeleteModal from './FtpDeleteModal'

interface Props {
    ftpConnections: z.infer<typeof FtpSchema>[],
    updateData: () => void
}

export default function FtpTable(props: Props) {
    return <div>
        <div>
            <h1 className="text-xl font-bold text-black dark:text-white mb-2">
                Ftp Connections
            </h1>
            <FtpModal updateData={props.updateData}>
                
            </FtpModal>
        </div>
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead>#</TableHead>
                    <TableHead>Name</TableHead>
                    <TableHead>Server</TableHead>
                    <TableHead>Username</TableHead>
                    <TableHead>Password (hidden)</TableHead>
                    <TableHead>CB Approved</TableHead>
                    <TableHead>Edit</TableHead>
                    <TableHead>Delete</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {props.ftpConnections?.map((connection, _index) => (
                    <TableRow key={connection.ID}>
                        <TableCell>{connection.ID}</TableCell>
                        <TableCell>{connection.Name}</TableCell>
                        <TableCell>{connection.Server}</TableCell>
                        <TableCell>{connection.Username}</TableCell>
                        <TableCell>**********</TableCell>
                        <TableCell>{connection.CB_approved == 1 ? <Check/> : <X/> }</TableCell>
                        <TableCell><FtpEditModal connection={connection} updateData={props.updateData}/></TableCell>
                        <TableCell><FtpDeleteModal connection={connection} updateData={props.updateData}/></TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </div> 
}